import type { SimpleChanges, TemplateRef } from '@angular/core';
import { booleanAttribute, ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Images } from './images';

export type IntegrationImage = keyof typeof Images;

@Component({
  selector: 'rti-svg-asset',
  templateUrl: './svg-asset.component.html',
  styleUrls: ['./svg-asset.component.less'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.horizontal-center]': 'centerHorizontally',
  },
})
export class SvgAssetComponent {
  public template: TemplateRef<any>;
  public assetPath: string;

  @Input() public name: IntegrationImage;
  @Input({ transform: booleanAttribute }) public centerHorizontally = true;

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.name) {
      this.updateAsset(this.name);
    }
  }

  private updateAsset(name: IntegrationImage) {
    const path = Images[name];
    if (!path) {
      // eslint-disable-next-line no-console
      console.info(`There is no image for ${name}`);
    }
    this.assetPath = `assets/integrations/images/${path}`;
  }
}
